import React, { Component } from 'react';
import classNames from 'classnames';
import { PlayButton, YouTubePlayer } from '../../atoms';

import './styles.css';

/**
 * A template for video playback sections.
 *
 * @typedef {Object} Props
 * @prop {String} heading
 * @prop {String} heading1
 * @prop {String} heading2
 * @prop {String} videoId
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
export default class VideoSection extends Component {

	state = {
		isVideoInitiated: false,
	};

	genClassName = (className) => classNames('VideoSection-wrap', className);

	handleClick = () => {
		this.setState({ isVideoInitiated: true });
	}

	render () {
		const { heading, heading1, heading2, videoId, className } = this.props;

		return (
			<section className='VideoSection'>
				{ heading ? <h1 className='VideoSection-heading'>{heading}</h1> : '' }
				<div className={this.genClassName(`${className}`)}>{this.state.isVideoInitiated
					? <YouTubePlayer className='VideoSection-player' videoId={videoId} />
					: <h1 className='VideoSection-play-wrap'>
						<span>{heading1}</span>
						<span>{heading2}</span>
						<span><PlayButton onClick={this.handleClick} /></span>
					</h1>
				}</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/VideoSection/VideoSection.js